export default __webpack_public_path__ + "static/media/close-up-side-portrait-happy-man-driving-car.9642e857.jpg";